import type { MailboxInfo } from "owa-client-types";
import getLeftNavGroups from "./getLeftNavGroups";

export default function getMyOrgGroups(mailboxInfo: MailboxInfo): string[] {
    return getLeftNavGroups(mailboxInfo)?.myOrgGroups ?? [];
}
